import { actionConstants } from './actionConstants';
import { get, post } from './method';
import noti from './toast';

export default {
  getAckAlarmsPhrases,
  getAckInfo,
  createAckAlarm,
};

function getAckAlarmsPhrases() {
  return async (dispatch) => {
    // dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/ackAlarms/phrases`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ACK_ALARMS_PHRASES_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_ACK_ALARMS_PHRASES_FAILURE,
          data: error.message,
        });
      });
  };
}

function getAckInfo(sensorIds) {
  return async (dispatch) => {
    return await get(`app/ackAlarms/info?sensorIds=${sensorIds.join(',')}`)
      .then((resp) => {
        // dispatch({
        //   type: actionConstants.GET_ACK_INFO_SUCCESS,
        //   data: resp,
        // });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
        // dispatch({
        //   type: actionConstants.GET_ACK_INFO_FAILURE,
        //   data: error.message,
        // });
      });
  };
}

function createAckAlarm(_params) {
  return async (dispatch) => {
    // dispatch({ type: actionConstants.START_QUERY });
    let params = {
      body: _params,
    };
    return await post(`app/ackAlarms`, params)
      .then((resp) => {
        dispatch({
          type: actionConstants.CREATE_ACK_ALARMS_SUCCESS,
        });
      })
      .then(() => noti.success('Acknowledge alarm is added'))
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.CREATE_ACK_ALARMS_FAILURE,
          data:
            error.response.data && error.response.data.error
              ? error.response.data.error.message
              : error.message,
        });
        throw error.response.data && error.response.data.error
          ? error.response.data.error.message
          : error.message;
      });
  };
}
